import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { adminApi } from '../api/admin';

const AdminAuthContext = createContext(null);

export const AdminAuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);     // user object or null
  const [checking, setChecking] = useState(true);

  const refresh = useCallback(async () => {
    if (!localStorage.getItem('dyssc_admin_token')) {
      setAdmin(null);
      setChecking(false);
      return;
    }
    try {
      const { data } = await adminApi.get('/admin/me');
      setAdmin(data);
    } catch (e) {
      console.debug('Admin session check failed:', e);
      setAdmin(null);
    } finally {
      setChecking(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const { data } = await adminApi.post('/admin/login', { email, password });
    localStorage.setItem('dyssc_admin_token', data.token);
    setAdmin({
      email: data.email,
      role: data.role,
      permissions: data.permissions || [],
      super: !!data.super,
      must_change_password: !!data.must_change_password,
      name: data.name || '',
    });
    return data;
  };

  const logout = async () => {
    try { await adminApi.post('/admin/logout'); } catch (e) { console.debug('Logout request failed (ignored):', e); }
    localStorage.removeItem('dyssc_admin_token');
    setAdmin(null);
  };

  const clearMustChange = () => {
    setAdmin((a) => (a ? { ...a, must_change_password: false } : a));
  };

  const hasPermission = (perm) => {
    if (!admin) return false;
    if (admin.super) return true;
    return (admin.permissions || []).includes(perm);
  };

  return (
    <AdminAuthContext.Provider value={{
      admin, checking, login, logout, refresh, clearMustChange, hasPermission,
    }}>
      {children}
    </AdminAuthContext.Provider>
  );
};

export const useAdminAuth = () => useContext(AdminAuthContext);
